import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportType } from '@/types/import';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

const validate = (model: string, importId: number) => {
  if (!model) {
    throw new Error('`model` is required');
  }
  if (!importId) {
    throw new Error('`importId` is required');
  }
};

type RequestParams = {
  model: DBImportType;
  importId: number;
};

type Response = {
  killed: boolean;
};

/** Cancels a running import: POST /{model}/import/kill/{importId}. */
export const killImport = async (
  scope: RequestScope,
  { model, importId }: RequestParams,
  requestOptions: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(model, importId);

    const result = await scopedApi(scope).post<EndpointResponse<Response>>(`${model}/import/kill/${importId}`, {}, requestOptions);

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
